<div fxFlex="100" fxLayoutGap="2px">
    <div fxLayout="column">
        <div *ngIf="productzoom==1||productzoom==4||productzoom==5 ||productzoom==6 || productzoom==7; else productsImageWidth ">
            <div *ngFor="let image of imageList; let i=index" >
            <div>
                <ng-container *ngIf="image=='sassa'">             
                    <img [alt]="name" src="src/assets/images/products/noImage/no-image.png">
                    </ng-container>
    
    
                <ng-container *ngIf="image!='sassa'">
                    <ng-container *ngIf="!image.includes('medicineimages')&&!image.includes('http')&&!image.includes('commonimages')">
                    <a (mouseenter)="selectImage(image,i)">
                        <ng-container>
                            <mat-card class="product-image collection-banner mat-elevation-z0" *ngIf="image !='no_selection'">                            
                            <div fxLayoutAlign="center center">
                                <calsoft-controls [data]="data"
                                 fxLayoutAlign="end center" 
                                 [product]="configProductSelected"
                                 [configproduct]="product"
                                  style="position: absolute;top :0;right: 0" [type]="'wishonly'">
                                </calsoft-controls>
                   
                            <div *ngIf="productzoom!==7;">
                                <img [alt]="name" [src]="bigImage+image | safe: 'resourceUrl'" [ngClass]="{'imgCursor': productzoom<5}" [ngStyle.gt-sm]
                                ="{height:productDetailHeight,width:productDetailWidth}" (mousemove)="productzoom<5?onMouseMove($event):''"
                                    (mouseleave)="productzoom<5?onMouseLeave($event):''"  (click)="productzoom==4?imagePreview(imageList , highlighted)
                                    :productzoom==6?imagePreview(imageList , highlighted):''"                              
                                    onerror="this.src='assets/images/products/noImage/no-image.png';" alt="">
                            </div>
                            <div *ngIf="productzoom==7;" class="image-container" style="cursor: pointer;">
                                <img [alt]="name" [src]="bigImage+image | safe: 'resourceUrl'" [ngClass]="{'imgCursor': productzoom<5}" [ngStyle.gt-sm]
                                ="{height:productDetailHeight,width
                                    :productDetailWidth}"
                                    onerror="this.src='assets/images/products/noImage/no-image.png';" alt="">
                                    <mat-icon class="zoom-icon" (click)="openlightBox()">zoom_out_map</mat-icon>
                            </div>
                            </div>
                            </mat-card>
                        </ng-container>
                    </a>
                    </ng-container>
    
                    <ng-container *ngIf="image.includes('http')">
                    <a (mouseenter)="selectImage2(image,i)">
                    <ng-container>
                        <mat-card class="product-image collection-banner mat-elevation-z0" *ngIf="image !='no_selection'">
                        <div fxLayoutAlign="center center">
                            <calsoft-controls [data]="data"
                             fxLayoutAlign="end center" 
                             [product]="configProductSelected"
                             [configproduct]="product"
                              style="position: absolute;top :0;right: 0" [type]="'wishonly'">
                            </calsoft-controls>
               
                        <div *ngIf="productzoom!==7;">                    
                        <img [alt]="name" [src]="image| safe: 'resourceUrl'" [ngClass]="{'imgCursor': productzoom<5}" [ngStyle.gt-sm]
                        ="{height:productDetailHeight,width:productDetailWidth}" (click)="productzoom==4?imagePreview(imageList , highlighted)
                        :productzoom==6?imagePreview(imageList , highlighted):''"
                        (mousemove)="productzoom<5?onMouseMove($event):''"
                        (mouseleave)="productzoom<5?onMouseLeave($event):''"      
                        onerror="this.src='assets/images/products/noImage/no-image.png';" alt="">
                        </div>
                        <div *ngIf="productzoom==7;" class="image-container" style="cursor: pointer;">                    
                            <img [alt]="name" [src]="image| safe: 'resourceUrl'" [ngClass]="{'imgCursor': productzoom<5}" [ngStyle.gt-sm]
                            ="{height:productDetailHeight,width
                            :productDetailWidth}"
                            onerror="this.src='assets/images/products/noImage/no-image.png';" alt="">
                            <mat-icon class="zoom-icon" (click)="openlightBox()">zoom_out_map</mat-icon>
                        </div>
                        </div>
                        </mat-card>
                    </ng-container>
                    </a>
                </ng-container>
    
                    <a (mouseenter)="selectImage1 (image,i)"
                    *ngIf="image.includes('medicineimages')">
                    <ng-container>
                        <mat-card class="product-image collection-banner mat-elevation-z0" *ngIf="image !='no_selection'">
                        <div fxLayoutAlign="center center">
                            <calsoft-controls [data]="data"
                             fxLayoutAlign="end center" 
                             [product]="configProductSelected"
                             [configproduct]="product"
                              style="position: absolute;top :0;right: 0" [type]="'wishonly'">
                            </calsoft-controls>
               
                        <div *ngIf="productzoom!==7;">
                        <img [alt]="name" [src]="commonImageApi+image| safe: 'resourceUrl'" [ngClass]="{'imgCursor': productzoom<5}" [ngStyle.gt-sm]
                        ="{height:productDetailHeight,width
                        :productDetailWidth}" (click)="productzoom==4?imagePreview(imageList , highlighted)
                        :productzoom==6?imagePreview(imageList , highlighted):''"
                        (mousemove)="productzoom<5?onMouseMove($event):''"
                        (mouseleave)="productzoom<5?onMouseLeave($event):''"            
                        onerror="this.src='assets/images/products/noImage/no-image.png';" alt="">
                        </div>
                        <div *ngIf="productzoom==7;" class="image-container" style="cursor: pointer;">
                            <img [alt]="name" [src]="commonImageApi+image| safe: 'resourceUrl'" [ngClass]="{'imgCursor': productzoom<5}" [ngStyle.gt-sm]
                            ="{height:productDetailHeight,width
                            :productDetailWidth}"
                            onerror="this.src='assets/images/products/noImage/no-image.png';" alt="">
                            <mat-icon class="zoom-icon" (click)="openlightBox()">zoom_out_map</mat-icon>
                            </div>
                        </div>
                    </mat-card>

                    </ng-container>
                    </a>
    
                    <a (mouseenter)="selectImage3 (image,i)"
                    *ngIf="image.includes('commonimages')">
                    <ng-container>
                        <mat-card class="product-image collection-banner mat-elevation-z0" *ngIf="image !='no_selection'">
                        <div fxLayoutAlign="center center">
                            <calsoft-controls [data]="data"
                             fxLayoutAlign="end center" 
                             [product]="configProductSelected"
                             [configproduct]="product"
                              style="position: absolute;top :0;right: 0" [type]="'wishonly'">
                            </calsoft-controls>
               
                        <div *ngIf="productzoom!==7;">
                        <img [alt]="name" [src]="serverPath7+image| safe: 'resourceUrl'" [ngClass]="{'imgCursor': productzoom<5}" [ngStyle.gt-sm]
                        ="{height:productDetailHeight,width
                        :productDetailWidth}" (click)="productzoom==4?imagePreview(imageList , highlighted)
                        :productzoom==6?imagePreview(imageList , highlighted):''"
                        (mousemove)="productzoom<5?onMouseMove($event):''"
                        (mouseleave)="productzoom<5?onMouseLeave($event):''"             
                        onerror="this.src='assets/images/products/noImage/no-image.png';" alt="">
                        </div>
                        <div *ngIf="productzoom==7;" class="image-container" style="cursor: pointer;">
                            <img [alt]="name" [src]="serverPath7+image| safe: 'resourceUrl'" [ngClass]="{'imgCursor': productzoom<5}" [ngStyle.gt-sm]
                            ="{height:productDetailHeight,width
                            :productDetailWidth}"
                            onerror="this.src='assets/images/products/noImage/no-image.png';" alt="">
                            <mat-icon class="zoom-icon" (click)="openlightBox()">zoom_out_map</mat-icon>
                            </div>
                        </div>
                        </mat-card>
                    </ng-container>
                    </a>
    
                </ng-container>
            </div>
            </div>
        </div>
        <ng-template #productsImageWidth>
            <mat-card class="collection-banner product-image1 mat-elevation-z0">
   
              <calsoft-imagezoom (click)="productzoom==3?imagePreview(imageList , highlighted):''"
                [thumbImage]="image" [fullImage]="image" [magnification]="1" [enableScrollZoom]="true"
                [enableLens]="true" [lensWidth]="200" [lensHeight]="200">
   
              </calsoft-imagezoom>
              <calsoft-controls [data]="data" fxLayoutAlign="end center" [product]="productIdAddedInCart"
                style="position: absolute;top :0;right: 0" [type]="'wishonly'">
              </calsoft-controls>
            </mat-card>
          </ng-template>
          <calsoft-product-icon [showGenuineProductIcon]="showGenuineProductIcon"
          [genuineProductText]="genuineProductText" [deliveryTime]="deliveryTime"
          [deliveryDoorStepText]="deliveryDoorStepText" [ColdChain]="ColdChain" [showTimeIcon]="showTimeIcon"
          [deliveryDoorStepIcon]="deliveryDoorStepIcon"
          [displayColdChain]="displayColdChain"></calsoft-product-icon> 
   
    </div>
</div>
